export interface PermissionDescriptor {
    readonly name: string;
}
export interface PermissionStatus {
    readonly state: string;
    onchange: Function;
}
export interface Permissions {
    query(permissionDescriptor: PermissionDescriptor): Promise<PermissionStatus>;
}
export const permissionsApi = (navigator: Navigator): Permissions | null => {
    if ("permissions" in navigator) {
        return navigator["permissions"] as Permissions;
    }
    return null;
};

